
// import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import '@babel/polyfill';
import 'react-app-polyfill/ie11';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store/appStore';
import './style/main.less';
import 'regenerator-runtime/runtime';
import { AzureAD, AuthenticationState } from 'react-aad-msal';
import { authProvider, authenticationParameters } from './authProvider';
ReactDOM.render(
  <React.StrictMode>
   <Provider store={store}>
      <AzureAD provider={authProvider} reduxStore={store} forceLogin={true}>
        {
          ({ login, logout, authenticationState, error, accountInfo }) => {
            const isAuthenticated = authenticationState === AuthenticationState.Authenticated;
            if (isAuthenticated) {
              return (<BrowserRouter>
                <App logout={logout} accountInfo={accountInfo} />
              </BrowserRouter>);
            } else {
              authProvider.loginRedirect();
              return null;
            }
          }}
        </AzureAD>
  </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
